/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllLabel,
  getAllVisibleTo,
  getCurrency,
} from "../../Redux/CommonSlice";
import { handleAddDeal } from "../../Redux/DealSlice";
import { removeLeadmaster } from "../../Redux/LeadsSlice";
import { fetchApiData, saveApiData } from "../../Redux/organizationSlice";
import { getAllPerson, handleAddPerson } from "../../Redux/PersonSlice";
import moment from "moment";
import { formatNumber, sourceChannel, PREFERRED_CONTACT_METHODS } from "../Common/Common";
import ReactSelect from "../Common/ReactSelect";
import AddLabel from "../Common/AddLabel";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PipelineStage from "../Common/pipelineStage";
import PhoneInput from "react-phone-input-2";
import { AddRowBtn, DeleteBtn } from "../Common/Buttons";

export default function AddDeals({ toggleModal, Deal, leadData, id, setloadFrist, name, dealID, UpdatePerson, }) {
  const { register, handleSubmit, setValue, watch, formState: { errors, isSubmitting }, } = useForm();

  const navigate = useNavigate()
  const dispatch = useDispatch();
  const store = useSelector((state) => state.root.common);
  const organizationstore = useSelector((state) => state.root.organization);
  const Peoplestore = useSelector((state) => state.root.Person);

  const [selectedMessage, setSelectedMessage] = useState("Qualified");
  const [selectedCurrency, setSelectedCurrency] = useState({ value: 63, label: "Indian Rupee(INR)", });
  const [openLabelModel, setOpenLabelModel] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(dealID ? { label: name, value: dealID } : null);
  const [SourceChannel, setSourceChannel] = useState('');
  const [selectedOrganization, setSelectedOrganization] = useState();
  const [selectedLable, setselectedLable] = useState(0);
  const [selectedVisible, setselectedVisible] = useState(1);
  const [allPhone, setAllPhone] = useState([{ phone: "", Type: "Home", country: 'in' }]);
  const [allEmail, setAllEmail] = useState([{ email: "", Type: "Home" }]);
  const [expectedCloseDate, setExpectedCloseDate] = useState(moment().format("YYYY-MM-DD"));
  const [Error, setError] = useState({});
  const [creatingPerson, setCreatingPerson] = useState(false);
  const [creatingOrganization, setCreatingOrganization] = useState(false);
  const [dealAddress, setDealAddress] = useState("");
  const [selectedContactMethod, setSelectedContactMethod] = useState(PREFERRED_CONTACT_METHODS[0]);
  const value = watch("Value");

  const resolveCreatedPersonId = (res, name, personList) => {
    const data = res?.payload?.data;
    if (data?.personMasterID) return data.personMasterID;
    if (typeof data === 'number') return data;
    const match = [...(personList || [])]
      .reverse()
      .find((p) => p.name?.toLowerCase() === name.toLowerCase());
    return match?.personMasterID;
  };

  const resolveCreatedOrgId = (res, name, orgList) => {
    const data = res?.payload?.data;
    if (data?.organizationID) return data.organizationID;
    if (typeof data === 'number') return data;
    const match = [...(orgList || [])]
      .reverse()
      .find((o) => o.organizationName?.toLowerCase() === name.toLowerCase());
    return match?.organizationID;
  };

  const handleCreatePerson = async (name) => {
    const trimmed = name?.trim();
    if (!trimmed) return;

    setCreatingPerson(true);
    try {
      const labelId = typeof selectedLable === 'object' ? selectedLable?.value : selectedLable;
      const visibleId = typeof selectedVisible === 'object' ? selectedVisible?.value : selectedVisible;

      const params = {
        personMasterID: 0,
        name: trimmed,
        organizationID: selectedOrganization?.value || 0,
        labelID: labelId ?? 0,
        ownerID: 0,
        visibleToID: visibleId ?? 1,
        userID: 0,
        personPhoneDetails: allPhone
          .filter((p) => p.phone?.trim())
          .map((p) => ({
            personPhoneDetailsID: 0,
            personMasterID: 0,
            phoneNumber: p.phone,
            phoneType: p.Type || 'Home',
          })),
        personEmailDetails: allEmail
          .filter((e) => e.email?.trim())
          .map((e) => ({
            personEmailDetailsID: 0,
            personMasterID: 0,
            email: e.email,
            emailType: e.Type || 'Home',
          })),
      };

      const res = await dispatch(handleAddPerson(params));
      if (res?.payload?.status !== true) return;

      const listRes = await dispatch(getAllPerson({}));
      const personList = listRes?.payload?.data ?? [];
      const newId = resolveCreatedPersonId(res, trimmed, personList);

      if (newId) {
        setSelectedPerson({ value: newId, label: trimmed });
      }
    } finally {
      setCreatingPerson(false);
    }
  };

  const handleCreateOrganization = async (name) => {
    const trimmed = name?.trim();
    if (!trimmed) return;

    setCreatingOrganization(true);
    try {
      const labelId = typeof selectedLable === 'object' ? selectedLable?.value : selectedLable;
      const visibleId = typeof selectedVisible === 'object' ? selectedVisible?.value : selectedVisible;

      const payload = {
        organizationID: 0,
        organizationName: trimmed,
        userID: 0,
        labelId: labelId ?? 0,
        ownerId: 0,
        address: '',
        visibleToId: visibleId ?? 1,
      };

      const res = await dispatch(saveApiData(payload));
      if (res?.payload?.status !== true) return;

      const listRes = await dispatch(fetchApiData({}));
      const orgList = listRes?.payload?.data ?? [];
      const newId = resolveCreatedOrgId(res, trimmed, orgList);

      if (newId) {
        setSelectedOrganization({ value: newId, label: trimmed });
      }
    } finally {
      setCreatingOrganization(false);
    }
  };

  useEffect(() => {
    dispatch(getCurrency({}));
    dispatch(getAllLabel({}));
    dispatch(getAllVisibleTo({}));
    dispatch(fetchApiData({}));
    dispatch(getAllPerson({}));
  }, []);

  useEffect(() => {
    if (Deal && Deal) {
      setValue("Title", Deal?.title);
      setValue("Value", Deal?.value);
      setValue("SourcechannelID", Deal?.sourceChannelID);
      if (Deal && Deal?.expectedCloseDate) { setExpectedCloseDate(moment(Deal?.expectedCloseDate).format("YYYY-MM-DD")) }
      if (Deal && Deal.peopleID) { setSelectedPerson({ label: Deal.personName, value: Deal.peopleID }); }
      if (Deal && Deal.organizationID) { setSelectedOrganization({ label: Deal?.organization?.organizationName, value: Deal.organizationID, }) }
      if (Deal && Deal.sourceChannel) { setSourceChannel({ label: Deal?.sourceChannel }) }
      if (Deal && Deal.labelID) setselectedLable({ label: Deal.labelName, value: Deal.labelID });
      if (Deal && Deal.visibleID) setselectedVisible({ label: Deal.visibleName, value: Deal.visibleID });
      if (Deal && Deal.currencyID) { setSelectedCurrency({ label: Deal.currencyName, value: Deal.currencyID, }); }
      if (Deal && Deal.pipelineStage) setSelectedMessage(Deal.pipelineStage ? Deal.pipelineStage : selectedMessage);
      if (Deal && Deal.dealPhoneDetails) { setAllPhone(Deal && Deal.dealPhoneDetails.map((x) => ({ phone: x.phoneNumber, Type: x.numberType, }))) }
      if (Deal && Deal.dealEmailDetails) { setAllEmail(Deal && Deal.dealEmailDetails.map((x) => ({ email: x.email, Type: x.type, }))); }
      if (Deal?.dealAddress) setDealAddress(Deal.dealAddress);
      if (Deal?.preferredContact) {
        const found = PREFERRED_CONTACT_METHODS.find(
          (m) => m.value === Deal.preferredContact || m.label === Deal.preferredContact
        );
        if (found) setSelectedContactMethod(found);
      }

    } else if (leadData && leadData) {
      setValue("Title", leadData?.title);
      setValue("Value", leadData?.value);
      setValue("SourcechannelID", leadData?.sourceChannelID);
      if (leadData && leadData.sourceChannel) { setSourceChannel({ label: leadData?.sourceChannel }) }
      if (leadData && leadData?.expectedCloseDate) { setExpectedCloseDate(moment(leadData?.expectedCloseDate).format("YYYY-MM-DD")) }
      if (leadData && leadData?.peopleID) { setSelectedPerson({ label: leadData.person.name, value: leadData.person.personMasterID }); }
      if (leadData && leadData?.organizationID) { setSelectedOrganization({ label: leadData?.organization?.organizationName, value: leadData.organization.organizationID, }) }
      if (leadData && leadData?.labelID) setselectedLable({ label: leadData.labelName, value: leadData.labelID });
      if (leadData && leadData?.visibleID) setselectedVisible({ label: leadData.visibleName, value: leadData.visibleID });
      if (leadData && leadData?.currencyID) { setSelectedCurrency({ label: leadData.currencyName, value: leadData.currencyID, }); }
      if (leadData && leadData?.leadPhoneDetails) { setAllPhone(leadData && leadData.leadPhoneDetails.map((x) => ({ phone: x.phoneNumber, Type: x.numberType, }))) }
      if (leadData && leadData?.leadEmailDetails) { setAllEmail(leadData && leadData.leadEmailDetails.map((x) => ({ email: x.email, Type: x.type, }))); }
      if (leadData?.leadAddress) setDealAddress(leadData.leadAddress);
      if (leadData?.preferredContact) {
        const found = PREFERRED_CONTACT_METHODS.find(
          (m) => m.value === leadData.preferredContact || m.label === leadData.preferredContact
        );
        if (found) setSelectedContactMethod(found);
      }
    }
  }, [Deal, leadData]);

  useEffect(() => {
    if (store?.getCurrency && selectedCurrency?.value) {
      const foundCurrency = store.getCurrency.find(x => x.value === selectedCurrency.value);
      if (foundCurrency && foundCurrency.type && !selectedCurrency.icon) {
        setSelectedCurrency(prev => ({
          ...prev,
          icon: foundCurrency.type
        }));
      }
    }
  }, [store?.getCurrency, selectedCurrency?.value]);

  const handleButtonClick = (message) => { setSelectedMessage(message); };

  const handlePhoneChange = (value, index, country) => {
    const updatedPhones = [...allPhone];
    updatedPhones[index] = { ...updatedPhones[index], phone: value };
    updatedPhones[index] = { ...updatedPhones[index], country: country?.dialCode };
    setAllPhone(updatedPhones);

    const newErrors = { ...Error };
    delete newErrors[`Phone-${index}`];
    setError(newErrors)
  };

  const handleEmailChange = (e, index) => {
    const { value } = e.target;
    const updatedEmails = [...allEmail];
    updatedEmails[index].email = value;
    setAllEmail(updatedEmails);

    const newErrors = { ...Error };
    delete newErrors[`Email-${index}`];
    setError(newErrors)
  };

  const handleEmailTypeChange = (e, index) => {
    const { value } = e.target;
    const updatedEmails = [...allEmail];
    updatedEmails[index].Type = value;
    setAllEmail(updatedEmails);
  };

  const handlePhoneTypeChange = (e, index) => {
    const { value } = e.target;
    const updatedPhones = [...allPhone];
    updatedPhones[index].Type = value;
    setAllPhone(updatedPhones);
  };

  const handleDelete = async (id) => {
    try {
      dispatch(removeLeadmaster(id));
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const validateFields = () => {
    const newErrors = {};

    const phoneNumbers = allPhone.map(item => item?.phone?.trim());
    const phoneNumberCount = phoneNumbers.reduce((count, phone) => {
      count[phone] = (count[phone] || 0) + 1;
      return count;
    }, {});

    allPhone.forEach((item, index) => {
      const phoneNumber = item?.phone?.trim();
      const countryCode = item?.country?.length

      if (!item.phone) {
        newErrors[`Phone-${index}`] = 'Phone Number is required';
      } else if ((countryCode === 1 && phoneNumber?.length <= 10) || (countryCode === 2 && phoneNumber?.length <= 11) || (countryCode === 3 && (phoneNumber?.length <= 10))) {
        newErrors[`Phone-${index}`] = 'Invalid Phone Number';
      } else if (phoneNumberCount[phoneNumber] > 1) {
        if (phoneNumbers.indexOf(phoneNumber) !== index) {
          newErrors[`Phone-${index}`] = 'Phone Number already exists';
        }
      }

    });
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const emailAddresses = allEmail.map(item => item?.email?.trim());
    const emailCount = emailAddresses.reduce((count, email) => {
      count[email] = (count[email] || 0) + 1;
      return count;
    }, {});

    allEmail.forEach((item, index) => {
      const email = item?.email?.trim();
      if (!email) {
        newErrors[`Email-${index}`] = 'Email is required';
      }
      else if (!emailRegex.test(email)) {
        newErrors[`Email-${index}`] = 'Invalid Email address';
      }
      else if (emailCount[email] > 1) {
        if (emailAddresses.indexOf(email) !== index) {
          newErrors[`Email-${index}`] = 'Email already exists';
        }
      }
    });
    return newErrors;
  };

  const onSubmit = async (data) => {
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) return setError(validationErrors);

    let PhoneDetails = [];
    let EmailDetails = [];

    allPhone?.map((item) => {
      let obj = {
        dealPhoneDetailID: 0,
        personMasterID: 0,
        phoneNumber: item?.phone,
        phoneType: item?.Type,
      };
      PhoneDetails?.push(obj);
    });

    allEmail?.map((item) => {
      let obj = {
        dealEmailDetailID: 0,
        email: item?.email,
        emailType: item?.Type,
      };
      EmailDetails?.push(obj);
    });

    let Params = {
      dealID: Deal?.dealID ? Deal?.dealID : 0,
      peopleID: selectedPerson?.value,
      organizationID: selectedOrganization?.value,
      title: data.Title,
      value: value ? value : 0,
      pipelineID: 0,
      pipelineStage: selectedMessage,
      CurrencyID: selectedCurrency && selectedCurrency?.value,
      labelID: selectedLable && selectedLable?.value,
      ownerID: 0,
      expectedCloseDate: expectedCloseDate,
      visibleID: selectedVisible && selectedVisible?.value,
      sourceChannelID: data?.SourcechannelID,
      sourceChannel: SourceChannel?.label,
      sourceType: "Manually created",
      userID: 0,
      projectID: 0,
      dealPhoneDetails: PhoneDetails,
      dealEmailDetails: EmailDetails,
      dealAddress: dealAddress?.trim() || "",
      preferredContact: selectedContactMethod?.value ?? 0,
      isWon: Deal?.isWon ? Deal?.isWon : Deal?.isWon === 0 ? 0 : 3,
      ProductMasterIDs: '',
      personMasterID: ''
    };

    try {
      if (leadData) {
        const id = leadData?.leadID
        handleDelete(id);
        const res = await dispatch(handleAddDeal(Params));
        if (res.payload.status === true) {
          toast.remove()
          toast.success('Lead Converted to Deal Successfully!')
          navigate("/LeadInbox")
          setloadFrist(true)
          toggleModal();
          setSelectedCurrency("");
          setAllEmail([{ email: "", Type: "Home" }]);
          setAllPhone([{ phone: "", Type: "Home" }]);
        }
      } else {
        const res = await dispatch(handleAddDeal(Params))
        if (dealID) {
          const data = res?.payload?.data
          UpdatePerson(data)
        }
        if (res.payload.status === true) {
          toggleModal();
          setloadFrist(true)
          setSelectedCurrency("");
          setAllEmail([{ email: "", Type: "Home" }]);
          setAllPhone([{ phone: "", Type: "Home" }]);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };


  const modalTitle = Deal?.dealID ? "Update Deals" : leadData ? "Convert to deal" : "Add Deals";
  const inputClass = "lead-modal-input";
  const labelClass = "lead-modal-label";
  const fieldClass = "lead-modal-field";
  const errorClass = "lead-modal-error";

  return (
    <>
      <div
        id="default-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="lead-modal-backdrop"
      >
        <div className="lead-modal-shell">
          <div className="lead-modal-card">
            <div className="lead-modal-header">
              <h3 className="lead-modal-title">{modalTitle}</h3>
              <AiOutlineCloseCircle
                className="lead-modal-close"
                onClick={() => toggleModal()}
              />
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="lead-modal-body">
                <div className="lead-modal-grid vertical-scroll-inner">
                  <div className="lead-modal-section">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot" />
                      <h4>Deal details</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      <div className={fieldClass}>
                        <label
                          htmlFor="deal-title"
                          className={labelClass}
                        >
                          Title
                        </label>
                        <input
                          type="text"
                          id="deal-title"
                          name="name"
                          placeholder="Enter Title"
                          className={`${inputClass} capitalize`}
                          {...register("Title", { required: "Title is required", })}
                        />
                        {errors.Title && (<p className={errorClass}>{errors.Title.message}</p>)}
                      </div>

                      <div className={fieldClass} >
                        <label
                          className={labelClass}
                        >
                          Pipeline
                        </label>
                        <PipelineStage selectedMessage={selectedMessage} setSelectedMessage={setSelectedMessage} handleButtonClick={handleButtonClick} />
                      </div>
                      <div className="lead-modal-row">
                        <div className={fieldClass}>
                          <label
                            htmlFor="Value"
                            className={labelClass}
                          >
                            Value
                          </label>
                          <input
                            type="text"
                            id="Value"
                            name="Value"
                            className={inputClass}
                            placeholder="Enter Value"
                            {...register("Value",)}
                            onChange={(e) => {
                              // Extract numeric value and set it in form state
                              const rawValue = e.target.value.replace(/[^0-9]/g, '');
                              setValue("Value", rawValue,);
                            }}
                            value={formatNumber(value)}
                          />
                        </div>
                        <div className={fieldClass}>
                          <label
                            className={labelClass}
                          >
                            Currency
                          </label>

                          <ReactSelect
                            Clearable={false}
                            selectedValue={selectedCurrency}
                            options={
                              store && store?.getCurrency?.length > 0
                                ? store?.getCurrency.map((item) => ({
                                  value: item?.value,
                                  label: item?.text,
                                  icon: item?.type,
                                }))
                                : [{ value: "", label: "Not Found" }]
                            }
                            handleSelectChange={(option) => setSelectedCurrency(option)}
                          />
                        </div>
                      </div>
                      <div className="lead-modal-row">
                        <div className={fieldClass}>
                          <label
                            htmlFor="SourcechannelID"
                            className={labelClass}
                          >
                            Source channel ID
                          </label>
                          <input
                            type="number"
                            id="SourcechannelID"
                            name="SourcechannelID"
                            className={inputClass}
                            placeholder="Enter Source channel ID"
                            {...register("SourcechannelID")}
                            min='0'
                          />
                        </div>
                        <div className={fieldClass}>
                          <label
                            className={labelClass}
                          >
                            Source channel
                          </label>
                          <ReactSelect
                            selectedValue={SourceChannel}
                            options={
                              sourceChannel && sourceChannel?.length > 0
                                ? sourceChannel.map((item) => ({
                                  value: item?.id,
                                  label: item?.name,
                                }))
                                : [{ value: "", label: "Not Found" }]
                            }
                            handleSelectChange={(option) => setSourceChannel(option)}
                          />
                        </div>
                      </div>
                      {!id ? (
                        <div className={fieldClass}>
                          <label
                            htmlFor="labelID"
                            className={labelClass}
                          >
                            Contact person
                          </label>
                          <ReactSelect
                            creatable
                            createEntityName="contact"
                            isLoading={creatingPerson}
                            selectedValue={selectedPerson}
                            options={
                              Peoplestore &&
                                Peoplestore?.getAllPerson?.length > 0
                                ? Peoplestore.getAllPerson.map((item) => ({
                                  value: item?.personMasterID ?? "",
                                  label: item?.name,
                                }))
                                : []
                            }
                            handleSelectChange={(option) => setSelectedPerson(option)}
                            onCreateOption={handleCreatePerson}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      <div className={fieldClass}>
                        <label
                          className={labelClass}
                        >
                          Comapany
                        </label>
                        <ReactSelect
                          creatable
                          createEntityName="company"
                          isLoading={creatingOrganization}
                          selectedValue={selectedOrganization}
                          options={
                            organizationstore &&
                              organizationstore?.organizationData?.data?.length > 0
                              ? organizationstore?.organizationData?.data.map(
                                (item) => ({
                                  value: item?.organizationID ?? "",
                                  label: item?.organizationName,
                                })
                              )
                              : []
                          }
                          handleSelectChange={(option) => setSelectedOrganization(option)}
                          onCreateOption={handleCreateOrganization}
                        />
                      </div>

                      <div className={fieldClass}>
                        <label
                          className={labelClass}
                        >
                          Labels
                        </label>
                        <div className="lead-modal-inline-control" >
                          <ReactSelect
                            selectedValue={selectedLable}
                            options={
                              store && store?.getAllLabel?.length > 0
                                ? store?.getAllLabel.map((item) => ({
                                  value: item?.value,
                                  label: item?.text,
                                }))
                                : [{ value: "", label: "Not Found" }]
                            }
                            handleSelectChange={(option) => setselectedLable(option)}
                          />
                          <AddRowBtn onClick={() => setOpenLabelModel(true)} label="Label" />
                        </div>
                      </div>

                      {/* <div className={fieldClass}>
                        <label className={labelClass}>
                          Owner
                        </label>
                        <select
                          className="lead-modal-type-select"
                          {...register("Owner")}
                          onChange={(e) => {
                            setValue("Owner", e.target.value);
                          }}
                        >
                          <option>User 1</option>
                          <option>User 2</option>
                          <option>User 3</option>
                          <option>User 4 </option>
                        </select>
                      </div> */}

                      <div className={fieldClass}>
                        <label className={labelClass}>
                          Expected Close Date
                        </label>
                        <input
                          type="date"
                          id="Default_Datepicker"
                          className={inputClass}
                          name="foo"
                          placeholder="MM/DD/YYYY"
                          defaultValue={new Date().toISOString().substr(0, 10)}
                          value={expectedCloseDate}
                          onChange={(e) => {
                            setExpectedCloseDate(e.target.value);
                          }}
                        />
                      </div>

                      <div className={fieldClass}>
                        <label
                          className={labelClass}
                        >
                          Visible to
                        </label>
                        <ReactSelect
                          selectedValue={selectedVisible}
                          options={
                            store && store?.getAllVisibleTo.length > 0
                              ? store?.getAllVisibleTo.map((item) => ({
                                value: item?.value,
                                label: item?.text,
                              }))
                              : [{ value: "", label: "Not Found" }]
                          }
                          handleSelectChange={(option) => setselectedVisible(option)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="lead-modal-section bg-transparent">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot lead-modal-section-dot-blue" />
                      <h4>Person contact</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      {/* Phone */}
                      <div className={fieldClass}>
                        <label className={labelClass}>
                          Phone <span className="lead-modal-required" aria-hidden="true"> *</span>
                        </label>
                        <div className="lead-modal-stack">
                          {allPhone?.map((item, index) => (
                            <div key={index} className="lead-modal-contact-row">
                              <div className="lead-modal-contact-input">
                                <PhoneInput
                                  country="in"
                                  value={item?.phone}
                                  onChange={(value, country) => handlePhoneChange(value, index, country)}
                                  containerClass="lead-phone-container"
                                  inputClass="lead-phone-input"
                                  buttonClass="lead-phone-button"
                                  inputProps={{ required: true }}
                                />
                                {Error[`Phone-${index}`] && (<p className={errorClass}>{Error[`Phone-${index}`]}</p>)}
                              </div>
                              {allPhone.length > 1 && (
                                <DeleteBtn onClick={() => setAllPhone(prev => prev.filter((_, i) => i !== index))} />
                              )}
                              {index === allPhone.length - 1 && (
                                <AddRowBtn onClick={() => setAllPhone(prev => [...prev, { phone: "", Type: "", country: 'in' }])} label="Phone" />
                              )}
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Email */}
                      <div className={fieldClass}>
                        <label className={labelClass}>
                          Email <span className="lead-modal-required" aria-hidden="true"> *</span>
                        </label>
                        <div className="lead-modal-stack">
                          {allEmail?.map((item, index) => (
                            <div key={index} className="lead-modal-contact-row">
                              <div className="lead-modal-contact-input">
                                <input
                                  type="text"
                                  placeholder="Enter email"
                                  className={inputClass}
                                  value={item?.email || ''}
                                  onChange={(e) => handleEmailChange(e, index)}
                                />
                                {Error[`Email-${index}`] && (<p className={errorClass}>{Error[`Email-${index}`]}</p>)}
                              </div>
                              {allEmail.length > 1 && (
                                <DeleteBtn onClick={() => setAllEmail(prev => prev.filter((_, i) => i !== index))} />
                              )}
                              {index === allEmail.length - 1 && (
                                <AddRowBtn onClick={() => setAllEmail(prev => [...prev, { email: "", Type: "" }])} label="Email" />
                              )}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className={fieldClass}>
                        <label className={labelClass}>Address</label>
                        <input
                          type="text"
                          className={inputClass}
                          placeholder="City, State, Country"
                          value={dealAddress}
                          onChange={(e) => setDealAddress(e.target.value)}
                        />
                      </div>

                      <div className={fieldClass}>
                        <label className={labelClass}>Preferred contact method</label>
                        <ReactSelect
                          selectedValue={selectedContactMethod}
                          options={PREFERRED_CONTACT_METHODS}
                          handleSelectChange={setSelectedContactMethod}
                          Clearable={false}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className="lead-modal-footer">
                <button
                  type="button"
                  className="px-4 py-2 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 text-sm font-semibold rounded-lg transition-colors cursor-pointer mr-2"
                  onClick={toggleModal}
                >
                  Close
                </button>
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting
                    ? "Saving..."
                    : Deal?.dealID
                      ? "Update"
                      : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {openLabelModel && (
        <AddLabel
          setOpenLabelModel={setOpenLabelModel}
          openLabelModel={openLabelModel}
        />
      )}
    </>
  );
}
